/**
 * What a choice or a drop does to a set of matches.
 *
 * Pure, and separate from the component for the same reason the ordering
 * helpers are: choosing what a gesture *means* is where the bugs live, and it
 * is testable without a layout. The dropdown and the drag both call these, so
 * the two can never disagree about what matching an item does.
 *
 * A match is a relation, not a position. Nothing here reads or writes an index.
 */
/**
 * Put `rightId` against `leftId`.
 *
 * A right item can only be in one place, so assigning one that is already on
 * another left item moves it rather than copying it. That is what keeps the
 * board one-to-one without the component having to police it.
 */
export function assign(matches, leftId, rightId) {
    const next = {};
    for (const [left, right] of Object.entries(matches)) {
        if (left !== leftId && right !== rightId)
            next[left] = right;
    }
    next[leftId] = rightId;
    return next;
}
/** Take whatever is on `leftId` back off it. */
export function clear(matches, leftId) {
    const next = {};
    for (const [left, right] of Object.entries(matches)) {
        if (left !== leftId)
            next[left] = right;
    }
    return next;
}
/** Which left item a right item is currently on, or undefined when it is free. */
export function leftHolding(matches, rightId) {
    return Object.entries(matches).find(([, right]) => right === rightId)?.[0];
}
/** The right items nobody has used yet, in the order they were given. */
export function unmatched(rightItems, matches) {
    const used = new Set(Object.values(matches));
    return rightItems.filter((item) => !used.has(item.id));
}
/** The wire shape: one entry per left item the student answered. */
export function toSubmittedMatches(matches) {
    return Object.entries(matches).map(([leftId, rightId]) => ({ leftId, rightId }));
}
/** And back, for a resumed attempt. */
export function fromSubmittedMatches(submitted) {
    const matches = {};
    for (const match of submitted)
        matches[match.leftId] = match.rightId;
    return matches;
}
//# sourceMappingURL=matching.js.map